import {
  getBaseUrl,
  Microservice,
} from "@funded-here-interface/common/src/constant/baseUrl";
import axios from "axios";
import { getApiResponseErrorMsg } from "@funded-here-interface/common/src/Utils/apiHelper";

type GetSignedDocRequest = {
  token: string;
  documentId: number;
};

const getDocumentSignatureStatusUpdate = async ({
  token,
  documentId,
}: GetSignedDocRequest) => {
  try {
    const response = await axios.get(
      `${getBaseUrl(Microservice.DOCUMENT_MANAGEMENT)}/document-management/document-sign/get-document-signature-status-update/${documentId}`,
      {
        headers: {
          "Content-Type": "application/json",
          Authorization: `Bearer ${token}`,
        },
        withCredentials: true,
      }
    );

    return response.data;
  } catch (e) {
    const message = getApiResponseErrorMsg(e);
    throw new Error(message);
  }
};

export default getDocumentSignatureStatusUpdate;
